import { type CustomFieldType } from 'src/api/generated';
import {
  formatCustomFieldLabel,
  parseCustomFieldValue,
} from 'src/modules/shared/utils/custom-fields.util';
import { resolveDateCustomFieldIncludeTime } from 'src/modules/shared/utils/custom-field-definition.util';
import { type CustomField } from 'src/modules/communications/types/custom-fields.type';

export function createCustomFieldFromDefinition(
  definitionId: number,
  fieldKey: string,
  fieldType: CustomFieldType,
  label: string | null | undefined,
  value: unknown,
  options?: { label: string; value: string }[],
  includeTime?: boolean
): CustomField {
  const name = label ?? formatCustomFieldLabel(fieldKey);

  const parsedValue = parseCustomFieldValue(value, fieldType);

  return {
    id: fieldKey,
    name,
    type: fieldType,
    value: parsedValue,
    includeTime: resolveDateCustomFieldIncludeTime(fieldType, includeTime),
    required: false,
    definitionId,
    options,
  };
}
